import React from 'react';

import LiveClassesList from '@magoosh/pages/live_classes/organisms/live_classes_list';
import RegistrationFormModal from '@magoosh/pages/live_classes/organisms/registration_form_modal';
import Icon from '@magoosh/pages/live_classes/assets/icons';
import style from '@magoosh/pages/live_classes/your_classes/style.module.scss';
import { pluralize } from 'utilities/pluralize';
import { useYourClassesContext } from '@magoosh/pages/live_classes/all_classes/context';

interface Props {
  descriptionHtml?: string;
}

export const YourClasses: React.FC<Props> = (props) => {
  const { data, fetchData } = useYourClassesContext();

  React.useEffect(() => {
    fetchData('yourClasses');
    const intervalId = setInterval(() => {
      fetchData('yourClasses', true);
    }, 1000 * 60);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  let title;
  if (data.yourClasses.filter((session) => !session.isLocked).length === data.yourClasses.length) {
    title = 'Your Classes';
  } else {
    title = 'Upcoming Classes';
  }

  return (
    <>
      <LiveClassesList
        icon={<Icon iconType="DateStar" fill={style.brandSecondary} />}
        title={title}
        description={props.descriptionHtml}
        liveClasses={data.yourClasses}
      />

      <RegistrationFormModal />
    </>
  );
};

export default YourClasses;
